import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  MerchandisingActions,
  isMerchandisingStateReady,
} from '@usf/ngrx-product';
import { Observable } from 'rxjs';
import {
  selectDeliveriesProductNumbers,
  selectDeliveriesViewModel,
} from '../selectors/deliveries.selectors';
import { DeliveriesViewModel } from '../models/deliveries-view-model';
import {
  MOST_POPULAR_EXPERIENCE,
  MOST_VIEWED_EXPERIENCE,
  REPLENISHMENT_EXPERIENCE,
  SEARCHED_ALSO_PURCHASED_EXPERIENCE,
  TRENDING_ITEMS_EXPERIENCE,
} from '@shared/constants/merchandising-constants';
import { MerchandisingExperience } from '@usf/product-types';

@Injectable({
  providedIn: 'root',
})
export class DeliveriesService {
  constructor(private store: Store) {}

  isMerchandisingStateReady$(): Observable<boolean> {
    return this.store.select(isMerchandisingStateReady);
  }

  getExperiencesRequest(searchTerm: string): MerchandisingExperience[] {
    return [
      {
        name: MOST_VIEWED_EXPERIENCE,
      },
      {
        name: TRENDING_ITEMS_EXPERIENCE,
      },
      {
        name: SEARCHED_ALSO_PURCHASED_EXPERIENCE,
        context: {
          eventType: 'monetate:context:SearchView',
          searchTerm,
          searchType: 'site',
          searchTermType: 'text',
        },
      },
      {
        name: REPLENISHMENT_EXPERIENCE,
      },
      {
        name: MOST_POPULAR_EXPERIENCE,
      },
    ];
  }

  fetchMerchandising(experiences: MerchandisingExperience[]): void {
    this.store.dispatch(
      MerchandisingActions.FetchMerchandisingResult({
        request: {
          experiences: experiences,
        },
      }),
    );
  }

  getDeliveriesProductNumbers$(
    experiences: MerchandisingExperience[],
  ): Observable<number[]> {
    return this.store.select(
      selectDeliveriesProductNumbers(
        experiences.map(experience => experience?.name),
      ),
    );
  }

  getDeliveriesViewModel$(
    experiences: MerchandisingExperience[],
  ): Observable<DeliveriesViewModel> {
    return this.store.select(
      selectDeliveriesViewModel(
        experiences.map(experience => experience?.name),
      ),
    );
  }
}
